// Single source of truth for the sessionStorage key holding the
// OpenWatch session JWT. Kept in its own tiny module so consumers
// (AuthProvider, the fetch wrapper, etc.) can import it WITHOUT
// pulling in the MSAL + Teams SDK that runAuthFlow transitively
// depends on. Critical for code splitting.
export const SESSION_KEY = "openwatch.session";
